export default __webpack_public_path__ + "static/media/IMG_5368.a9d65520.WEBP";